import { QueryClient, useQuery } from '@tanstack/react-query';
import { getFooterMenu } from '@/shared/api/menus/getFooterMenu';

type Params = Parameters<typeof getFooterMenu>[0];

export const useGetFooterMenu = (params: Params) => {
  return useQuery({
    queryKey: getUseGetFooterMenuQueryKey(params),
    queryFn: () => getFooterMenu(params),
    staleTime: Infinity,
  });
};

export const prefetchGetFooterMenu = async (
  queryClient: QueryClient,
  params: Params
) => {
  await queryClient.prefetchQuery({
    queryKey: getUseGetFooterMenuQueryKey(params),
    queryFn: () => getFooterMenu(params),
  });
};

export const getUseGetFooterMenuQueryKey = (params: Params) => [
  'getFooterMenu',
  params,
];
